import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedStateService {
  private showManualFormSubject = new BehaviorSubject<boolean>(false);
  showManualForm$ = this.showManualFormSubject.asObservable();

  setShowManualForm(value: boolean) {
    this.showManualFormSubject.next(value);
  }
}
